import { deepClone } from '@/server/utils';

export const types = {
    INIT: '/user/pages/productedit/init',
    CONCAT: '/user/pages/productedit/concat',
    INPUT: '/user/pages/productedit/input',
    NEXT: '/user/pages/productedit/next',
    PREV: '/user/pages/productedit/prev',
    CLEAR: '/user/pages/productedit/clear'
};

export interface IProductEditState { 
    step: number; // 步骤
    proCategory: any[]; // 产品分类
    appCategory: any[]; // 应用分类
    productName: string; // 产品名称
    productEnName: string; // 产品英文名称
    chemicalName: string; // 化学名称
    chemicalFormula: string; // 化学式
    molecular: string; // 分子量
    cas: string; // CAS号
    desc: string; // 产品描述
    munufacturer_id: string | number; // 供应商id
    munufacturer_name: string; // 供应商名称
    munufacturer_abbreviation: string; // 供应商简称
    brand: string; // 牌号
    model: string; // 型号
    country: string; // 国籍
    addressInfo: any; // 地址信息
    foreignAddress: string; // 外籍地址
    color: string; // 颜色
    period: string; // 保质期
    appearance: string; // 外观
    logo: string; // logo
    storage: string; // 储存条件
    performance: string[]; // 性能特点
    tds: string; // tds
    msds: string; // msds
    parameter: any[]; // 参数
}

export interface IProductEditAction { 
    type: string;
    data?: {
        key: string;
        value: any;
    };
    initData?: any;
    concatData?: any;
}

// 上一步
export function prevAction(): IProductEditAction { 
    return {
        type: types.PREV
    }
}

// 下一步
export function nextAction(): IProductEditAction { 
    return {
        type: types.NEXT
    }
}

const initState: IProductEditState = { 
    step: 1,
    proCategory: [
        {
            lv1: {},
            lv2: {},
            lv3: {}
        }
    ],
    appCategory: [
        {
            lv1: {},
            lv2: {},
            lv3: {},
            lv4: {},
        }
    ],
    productName: '',
    productEnName: '',
    chemicalName: '',
    chemicalFormula: '',
    molecular: '',
    cas: '',
    desc: '',
    munufacturer_id: '',
    munufacturer_name: '',
    munufacturer_abbreviation: '',
    brand: '',
    model: '',
    country: '',
    foreignAddress: '',
    addressInfo: {},
    color: '',
    period: '',
    appearance: '',
    logo: '',
    storage: '',
    performance: [''],
    tds: '',
    msds: '',
    parameter: [{
        id: '', // 物性值id
        name: '', // 名称
        physical: '', // 物性值
        unit: '', // 单位
        unitId: '', // 单位id
        remarks: '', // 备注
    }]
}

const emptyState:any = deepClone(initState);


export default (state: IProductEditState = initState, action: IProductEditAction): IProductEditState => { 
    switch (action.type) { 
        case types.INPUT:
            return {
                ...state,
                [action.data!.key]: action.data!.value
            }
        case types.NEXT:
            return {
                ...state,
                step: state.step + 1
            }
        case types.PREV:
            return {
                ...state,
                step: state.step - 1
            }
        case types.CONCAT:
        console.log('concat', action.concatData)
            return {
                ...state,
                ...action.concatData
            }
        case types.CLEAR:
            return deepClone(emptyState);
        case types.INIT:
            if (action.initData) {
                return {
                    ...state,
                    ...action.initData
                }
            } else { 
                return state;
            }
        default:
            return state;
    }
}